import createVueApp from '@phoenix/createVueApp';
import StrapSearchResultHeader from '@maison/components/strap-search/StrapSearchResultHeader.vue';

const app = createVueApp({}, true);
app.component('StrapSearchResultHeader', StrapSearchResultHeader);
app.mount('#phoenix-strap-search-result-header');
